<h1 mat-dialog-title>Alarmas activas</h1>
<div mat-dialog-content>
  <mat-divider class="mat-divicer-style"></mat-divider>
  <div *ngFor="let alarma of data">
    <p class="negro">Creada en: <span class="gris">{{ alarma.created_at }}</span></p>
    <p class="negro">Reference: <span class="gris">{{ alarma.dev_reference }}</span></p>
    <p class="negro">Etiqueta: <span class="gris">{{ alarma.dev_label }}</span></p>
    <p class="negro">Tipo de alarma: <span [ngStyle]="{'color': alarma.backgroundColor}">{{ alarma.status }}</span></p>
      <!--<ng-container *ngIf="alarma.status === 'T'">
        <span class="gris">Fallo Tensión Eléctrica</span>
      </ng-container>
      <ng-container *ngIf="alarma.status === 'O'">
        <span class="gris">Fallo Comunicación Dispositivo</span>
      </ng-container>
      <ng-container *ngIf="alarma.status === null">
        <span class="gris">No expecificado</span>
      </ng-container>
    </p>-->
    <mat-divider class="mat-divicer-style"></mat-divider>
  </div>
  <p *ngIf="data.length === 0" class="negro">Ningún dispositivo tiene alarmas</p>
</div>
<div mat-dialog-actions class="mat-dialog-actions align-end">
  <button mat-button mat-dialog-close cdkFocusInitial class="margin-left-auto">Ok</button>
</div>